import { useState, useEffect } from 'react';
import apiClientFactory from '../backend/apiClient';

const useDomainChecker = () => {
    const [loading, setLoading] = useState(false);
    const [domain, setDomain] = useState(false);
    const [domainError, setDomainError] = useState('');
    const apiClient = apiClientFactory();
    const MAIN_URL = process.env.REACT_APP_HOST;

    const checkDomain = async () => {
        const hostName = window.location.hostname.replace("www.", "");
        const domainName = hostName.split(".")[0];
        setLoading(true);

        // Check cache first
        // const cachedDomain = localStorage.getItem("DomainDetails");
        const cachedDomain = sessionStorage.getItem("DomainDetails");
        

        if (
            hostName === MAIN_URL ||
            domainName.toLowerCase() === "login" ||
            domainName.toLowerCase() === "develop" ||
            cachedDomain === domainName
        ) {
            setDomain(true);
        } else if (!cachedDomain) {
            try {
                const res = await apiClient.post("/users/checkdomain", {
                    domain: domainName,
                });
                const data = res.data;
                if (data.success) {
                    setDomain(true);
                    // Cache in localStorage instead of sessionStorage for persistence
                    // localStorage.setItem("DomainDetails", data.response.domain);
                    // localStorage.setItem("logo", data.response.logo);
                    sessionStorage.setItem("DomainDetails", data.response.domain);
                    sessionStorage.setItem("logo", data.response.logo);
                }
            } catch (error) {
                const err = error.response.data.message;
                console.log(err);
                setDomainError(err);
                setDomain(false);
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        checkDomain();
    }, []); // Run when hook is initialized

    return { loading, domain, domainError };
};

export default useDomainChecker;